function ScriptListController(psaService, $rootScope, $scope) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.psaService = psaService;
    ctrl.scriptList = null;
    ctrl.$rootScope = $rootScope;
    ctrl.loadScripts();
    ctrl.refreshScriptList();
  };

  ctrl.loadScripts = () => {
    ctrl.psaService.getScripts().then(
      response => {
        ctrl.scriptList = response;
      },
      error => {
        console.log(error);
      }
    );
  };

  ctrl.refreshScriptList = () => {
    let unbind = ctrl.$rootScope.$on('refreshScriptList', function(event) {
      ctrl.loadScripts();
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.selectScript = (script, index) => {
    ctrl.$rootScope.$emit('selectScript', script);
  };

  ctrl.createScript = () => {
    ctrl.$rootScope.$emit('createScript');
  };
}

angular
  .module('psa.module')
  .controller('ScriptListController', ScriptListController);
